<template>

    <div class="index">

        <div class="swiper-container-big swiper-container relative">

            <div class="swiper-wrapper relative">

                <div
                    class="swiper-slide top-swiper-slide relative"
                    v-for="(item,index) in top_banner"
                    :key="'banner-'+index"
                >
<!--                    <div v-if="selected !== index" class="mask"></div>-->

                    <v-image class="top-swiper-slide-img pointer" :src="item.path || '' " @click="openLinkPage(item)"></v-image>

                    <div class="absolute banner-title cf">

                        <div class="fl swiper-title line1">{{item.name || ''}}</div>

                        <div class="fr diagonal relative">
                            <div class="absolute top-num">{{index + 1}}</div>
                            <div class="absolute under-num">{{top_banner.length}}</div>
                        </div>

                    </div>

                </div>

            </div>

            <div class="swiper-button-next absolute"></div>

            <div class="swiper-button-prev absolute"></div>

        </div>

        <div class="content">

            <div class="list cf">

                <div class="list-box fl relative">

                    <div class="swiper-container swiper-container-small">

                        <div class="swiper-wrapper">

                            <div
                                class="swiper-slide"
                                v-for="(item,index) in indexInfo.bottom_banner"
                                :key="'swiper-slide'+index"
                            >

                                <v-image class="banner-image pointer" :src="item.path || ''" @click="openLinkPage(item)" />

                            </div>

                        </div>

                    </div>

                    <div class="swiper-small-log absolute">

                        <div class="swiper-small-inner relative">

                            <div class="swiper-small-up absolute">{{selected_small + 1}}</div>

                            <div class="swiper-small-under absolute">{{bottom_banner.length }}</div>

                        </div>

                    </div>

                </div>

                <!-- top榜单 -->
                <div class="list-center fl">

                    <div class="list-center-title">

                        <img src="../../assets/images/home_img_list@2x.png" />

                    </div>

                    <div
                        class="list-center-box pointer cf"
                        v-for="(item,index) in indexInfo.article"
                        :key="'list-center-box-' + index"
                        @click="openPage(item)"
                    >

                        <div class="list-index fl">{{ index + 1 }}</div>

                        <div class="list-content line1 fl">{{ item.name }}</div>

                    </div>

                </div>

                <div class="list-box fl relative pointer" @click="openTopic">

                    <v-image class="banner-image" :src="indexInfo.hot_topic.picture"></v-image>

                    <div class="absolute up-mask"></div>

                    <div class="bottom-box absolute">

                        <div class="bottom-title relative">

                            <line-title :width="84" background-color="#333333">

                                <div class="bottom-title-text">热门话题</div>

                            </line-title>

                        </div>

                        <div class="bottom-text">#{{ indexInfo.hot_topic.title || '' }}#</div>

                    </div>

                </div>

            </div>

            <div class="active cf">

                <div class="active-left fl cf">

                    <div class="active-left-item fl" v-for="(item,index) in indexInfo.star">

                        <star-avatar-item :data="item"/>

                    </div>

                </div>

                <div class="active-right fr">

                    <div class="active-right-title">活动</div>

                    <line-title />

                    <div class="active-content">

                        <div
                            class="active-item cf"
                            v-for="(item,index) in activity"
                            :key="'active-item-' + index"
                        >

                            <v-image
                                class="active-item-img fl pointer"
                                :src="item.picture || ''"
                                @click="openActive(item)"
                            />

                            <div class="active-item-right fr">

                                <div class="active-item-title bold line1">{{ item.title }}</div>

                                <div class="active-item-title">活动内容：<span>{{ item.type == 1 ? '福利' : '应援' }}</span></div>

                                <div class="active-item-title">人数：{{ item.join_count }}</div>

                                <div class="active-item-title">时间：{{ item.time_start }}-{{ item.time_end }}</div>

                                <button class="active-item-btn" @click="openActive(item)">我要参与</button>

                            </div>

                        </div>

                    </div>

                    <line-title :width="125">

                        <button class="line-box absolute" @click="nextActive">换一组</button>

                    </line-title>

                </div>
            </div>

            <div v-if="headline.length > 0" class="headline">

                <line-title :width="516" background-color="#333333" :height="50">

                    <div class="line-img-title">

                        <img src="../../assets/images/home_img_title@2x.png" />

                    </div>

                </line-title>

                <div class="headline-box cf">

                    <div class="fl news-list">

                        <div
                            class="news-item pointer"
                            v-for="(item,index) in headline"
                            :key="'news-item-'+index"
                            @click="openPage(item)"
                        >

                            <div class="news-item-tag">[{{ item.category }}]</div>

                            <div class="news-item-title">{{ item.name }}</div>

                            <div class="news-item-imgs" v-if="item.photo.length > 0">

                                <v-image
                                    class="news-item-imgs-img"
                                    v-for="(cItem,cIndex) in item.photo"
                                    :key="'item-img-'+cIndex"
                                    :src="cItem"
                                    @click.stop="openBigPhoto(cIndex,item)"
                                ></v-image>

                            </div>
                        </div>

                        <button class="news-more" @click="getMore">{{ showMore ? '更多' : '没有更多了' }}</button>

                    </div>

                    <div class="fr post-list">

                        <v-image
                            class="post-item pointer"
                            :style="{height: index%2 === 0 ? 320 +'px' : 415 + 'px'}"
                            v-for="(item,index) in hot_star"
                            :key="'post-item-'+index"
                            :src="item.picture"
                            :title="item.name"
                            @click="openStar(item)"
                        ></v-image>

                    </div>

                </div>

            </div>

        </div>

        <div class="download">

            <div class="download-box cf">

                <div class="download-box-img fl">

                    <img src="../../assets/images/home_img_app@2x.png" />

                </div>

                <div class="download-right fr cf">

                    <div
                        class="download-item fl cf"
                        v-for="(item,index) in downloadList"
                        :key="'download-item-'+index"
                    >

                        <img class="download-item-img fl" :src="item.icon"/>

                        <div class="download-item-right fl">

                            <div class="download-name">{{ item.name }}</div>

                            <img class="download-img" :src="item.image" />

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <overlay :show="is_big" @close="is_big = false">

            <div class="overlay-wrapper relative">

                <el-carousel
                    style="width: 1200px;"
                    height="400px"
                    arrow="always"
                    indicator-position="none"
                    :initial-index="initial_index"
                >

                    <el-carousel-item
                        v-for="(item,index) in photo"
                        :key="'carousel-item-'+index"
                    >

                        <img class="carousel-item-img" :src="item">

                    </el-carousel-item>

                </el-carousel>

            </div>

        </overlay>

        <div v-if="show_fixed" class="index-fixed">

            <div class="index-fixed-inner relative">

                <img
                    class="index-fixed-close absolute pointer"
                    src="../../assets/images/pop_icon_closed@2x.png"
                    @click="show_fixed = false"
                />

                <div class="index-fixed-head">
                    <span>明星头条APP</span>
                    开启你的追星之旅
                </div>

                <div class="index-fixed-center cf">

                    <img class="index-fixed-center-img fl" :src="download_img" />

                    <div class="index-fixed-button fl">

                        <div
                            class="index-fixed-btn pointer cf"
                            :class="[ index === 0 ? 'select-btn' : '' ]"
                            v-for="(item,index) in fixedBtns"
                            :key="'index-fixed-btn-'+index"
                            @click="changeBtn(item,index)"
                        >

                            <img class="fl"  :src="item.icon"/>

                            <div class="fl">{{ item.name }}</div>

                        </div>

                    </div>

                </div>

                <div class="index-fixed-floor cf">

                    <img class="fl" src="../../assets/images/fixed/pop_icon_benefit@2x.png" />

                    <div class="fl">签名照、明星周边每日派送</div>

                </div>

                <div class="index-fixed-floor cf">

                    <img class="fl" src="../../assets/images/fixed/pop_icon_idols@2x.png" />

                    <div class="fl">明星探班、见面会笔芯粉丝专享</div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import StarAvatarItem from '../../layout/starAvatarItem/main';
import LineTitle from '../../layout/lineTitle/main';
import Overlay from '@/components/overlay/main';
import vImage from '@/components/image';
import mixin from './mixin/mixin';

export default {
    name: "index",
    components: {
        StarAvatarItem,
        LineTitle,
        vImage,
        Overlay
    },
    mixins: [mixin]
}

</script>

<style scoped src="./style.css"></style>
<style>
.mask_k {
    width: 1200px;
    height: 550px;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 5;
}

.none {
    display: none;
}

.block {
    display: block;
}
</style>
